import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Input, Select } from 'components/fields'

export default class Address extends Component {
  static propTypes = {
    countries: PropTypes.array,
    optionalState: PropTypes.bool,
    prefix: PropTypes.string,
    isPayment: PropTypes.bool,
    isPostal: PropTypes.bool,
    showFirstLine: PropTypes.bool,
    showSecondLine: PropTypes.bool,
    showCity: PropTypes.bool,
    showZipCode: PropTypes.bool,
    showRegion: PropTypes.bool,
    showCountry: PropTypes.bool,
    showPhone: PropTypes.bool
  }

  static defaultProps = {
    prefix: null,
    optionalState: false,
    showFirstLine: true,
    showSecondLine: true,
    showCity: true,
    showZipCode: true,
    showRegion: true,
    showCountry: true,
    showPhone: true
  }

  render() {
    const {
      countries, optionalState, isPayment, isPostal, showCountry, showPhone,
      showFirstLine, showSecondLine, showCity, showZipCode, showRegion,
    } = this.props
    const prefix = this.props.prefix && this.props.prefix.length > 0
      ? `${this.props.prefix}.`
      : ''

    const colClass = !isPayment ? 'col-xs-12 col-sm-6 col-md-4' : ''
    const rowClass = !isPayment ? 'row' : ''

    return (
      <div>
        {(isPayment && !isPostal) &&
          <div className={colClass}>
            <Input
              name={`${prefix}email`}
              label='Email'
              intlKey='email'
              disabled
            />
          </div>}

        {(isPayment && showPhone && !isPostal) &&
          <div className={colClass}>
            <Input
              name={`${prefix}phoneNumber`}
              label='Phone'
              intlKey='label.phone'
            />
          </div>}

        {showFirstLine && <div className={rowClass}>
          <div className={colClass}>
            <Input
              name={`${prefix}line1`}
              label='Address First Line'
              intlKey='label.address_first_line'
              dataTestId='firstLineSelector'
              maxLength={255}
            />
          </div>
        </div>}

        {showSecondLine &&
          <div className={rowClass}>
            <div className={colClass}>
              <Input
                name={`${prefix}line2`}
                label='Address Second Line(Optional)'
                intlKey='label.address_second_line'
                dataTestId='secondLineSelector'
                maxLength={255}
              />
            </div>
          </div>}

        {(showCity || showZipCode) &&
          <div className={rowClass}>
            {showCity && <div className={colClass}>
              <Input
                name={`${prefix}city`}
                label='City'
                intlKey='label.city'
                dataTestId='citySelector'
              />
            </div>}

            {showZipCode && <div className={colClass}>
              <Input
                name={`${prefix}zipCode`}
                label='Zip / Postal code'
                intlKey='label.zip'
                dataTestId='zipCodeSelector'
              />
            </div>}
          </div>}

        {(showRegion || countries) && <div className={rowClass}>
          {showRegion && <div className={colClass}>
            <Input
              name={`${prefix}stateOrProvinceOrRegion`}
              label='State/Province/Region'
              intlKey='label.region'
              optional={optionalState}
              dataTestId='provinceSelector'
            />
          </div>}

          {(showCountry && countries) &&
            <div className={colClass}>
              <Select
                name={`${prefix}addressCountryId`}
                label='Country'
                intlKey='label.country'
                options={countries}
                searchable
                dataTestId='countrySelector'
              />
            </div>}
        </div>}
      </div>
    )
  }
}
